import React from 'react'
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Col,
  Row,
} from 'react-bootstrap'
import { JsonLd } from 'src/views/components/JsonLd'
import { breadcrumbSchema } from 'src/models/Schema'
import { Link, withRouter } from 'react-router-dom'
import { isMerchPLP, getBuyNowInPDP } from 'config/appConfig'
import {
  isExpressCheckout,
  parseMenuCategory,
  i18nTranslate,
  enablePlpRedesign,
  enablePdpRedesign,
  enablePersonalOfferPDP,
} from 'src/utils'
import './styles.scss'
import fullArrowLeft from 'src/views/components/Icons'
import { isEquinoxMysite, isEquinoxPOSite } from 'src/utils/mySiteUtils'

class BreadCrumb extends React.Component {
  getBreadCrumbList = (list = {}, index = 0) => {
    const labelText = parseMenuCategory(list.label || '')
    if (labelText !== '') {
      const baseKey = `${labelText}-${list.value || ''}-${index}`
      return (
        <React.Fragment key={baseKey}>
          {list.isLastElement ? (
            <BreadcrumbItem
              className="breadcrumb-item-list text-truncate"
              data-testid="qa-breadcrumb"
              aria-current="page"
              key={`${baseKey}-last`}
              active>
              {labelText}
            </BreadcrumbItem>
          ) : (
            <BreadcrumbItem
              key={`${baseKey}-link`}
              className="breadcrumb-item-list text-truncate flex-shrink-0"
              data-testid="qa-breadcrumb"
              linkProps={{ to: list.value }}
              linkAs={Link}>
              <span>{labelText}</span>
            </BreadcrumbItem>
          )}
        </React.Fragment>
      )
    }
    return <></>
  }
  // ...existing code...

  handleBackClick = () => {
    const { history } = this.props
    if (window.history.length > 1) {
      window.history.back()
    } else {
      history?.push?.('/product')
    }
  }

  render() {
    if (isMerchPLP) {
      return <></>
    }

    // EXTENDED PROPS to support PDP redesign back-to-category pattern
    const {
      breadCrumbList = [],
      location = '',
      backToCategoryLabel = '',
      backToCategoryLink = '',
      forceBackToCategory = false,
    } = this.props || {}

    const isPdpRedesign = enablePdpRedesign()
    const isPlpRedesign = enablePlpRedesign()
    const isPlpPdpRedesign = enablePlpRedesign() || enablePdpRedesign()
    const isPersonalOfferPDPEnabled = enablePersonalOfferPDP()
    // Filter out empty breadcrumbs and pass index for unique keys
    const validBreadcrumbs = breadCrumbList.filter(item => item?.label)
    const view = validBreadcrumbs.map((item, index) =>
      this.getBreadCrumbList(item, index)
    )
    const schemaData = breadcrumbSchema(validBreadcrumbs, location)

    let finalBackToCategoryLabel = backToCategoryLabel
    let finalBackToCategoryLink = backToCategoryLink

    if (isPersonalOfferPDPEnabled) {
      const lastBreadcrumb = breadCrumbList[breadCrumbList.length - 1] || {}
      const breadcrumbBackLabel = lastBreadcrumb.backToCategoryLabel || ''
      const breadcrumbBackLink = lastBreadcrumb.backToCategoryLink || ''
      finalBackToCategoryLabel = breadcrumbBackLabel || backToCategoryLabel
      finalBackToCategoryLink = breadcrumbBackLink || backToCategoryLink
    }

    const showBackToCategory =
      (isPdpRedesign || isEquinoxMysite()) &&
      ((finalBackToCategoryLabel && finalBackToCategoryLink) ||
        forceBackToCategory)

    if (showBackToCategory) {
      const categoryLabel = parseMenuCategory(finalBackToCategoryLabel)
      const backToText = i18nTranslate('back_to_title', 'Back to')

      const cleanupTrailingSlashIfPO = () => {
        if (
          typeof window === 'undefined' ||
          !window.history?.replaceState ||
          !isEquinoxPOSite()
        ) {
          return
        }
        Promise.resolve().then(() => {
          const { pathname, search, hash } = window.location
          if (pathname.length > 1 && pathname.endsWith('/')) {
            const trimmed = pathname.replace(/\/+$/, '')
            window.history.replaceState(
              window.history.state,
              '',
              `${trimmed}${search}${hash}`
            )
          }
        })
      }

      if (
        isPersonalOfferPDPEnabled &&
        (!finalBackToCategoryLink || !categoryLabel)
      ) {
        return <></>
      }

      return (
        <>
          <div
            className={`mobile-breadcrumb ${isPlpPdpRedesign ? 'plp-pdp-redesign' : ''} back-to-category d-flex align-items-center px-3 py-2`}
            style={{ cursor: finalBackToCategoryLink ? 'pointer' : 'default' }}
            onClick={() => {
              if (!finalBackToCategoryLink) return
              this.props?.history?.push?.(finalBackToCategoryLink)
              cleanupTrailingSlashIfPO()
            }}
            data-testid="qa-breadcrumb-back-category"
            aria-label={
              finalBackToCategoryLink
                ? `${backToText} ${categoryLabel}`
                : 'loading category'
            }>
            <Link
              to={
                finalBackToCategoryLink && categoryLabel
                  ? finalBackToCategoryLink
                  : '/'
              }
              onClick={cleanupTrailingSlashIfPO}
              aria-label={i18nTranslate('back_button_label', 'Back button')}
              className="text-decoration-none">
              <div className="arrow-icon me-2" aria-hidden="true">
                {/* Larger back icon for redesign */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7.75 12c0-.309.241-.5.541-.5h9.418c.3 0 .541.191.541.5s-.241.5-.541.5h-9.418c-.3 0-.541-.191-.541-.5z"
                    fill="#5F5F5F"
                  />
                  <path
                    d="M6.25 12.317c-.198-.198-.198-.518 0-.716l5.06-5.06c.198-.198.518-.198.716 0s.198.518 0 .716L7.323 12l4.603 4.603c.198.198.198.518 0 .716-.198.198-.518.198-.716 0l-5.06-5.06z"
                    fill="#5F5F5F"
                  />
                </svg>
              </div>
            </Link>
            {finalBackToCategoryLink && categoryLabel ? (
              <Link
                to={finalBackToCategoryLink}
                onClick={cleanupTrailingSlashIfPO}
                aria-label={`${backToText} ${categoryLabel}`}
                className="back-text text-decoration-none text-body">
                {backToText} {categoryLabel}
              </Link>
            ) : (
              <Link
                to={'/'}
                aria-label={`${backToText} ${i18nTranslate(
                  'breadCrumb.home',
                  'Home',
                  {
                    nameSpace: 'ssr-resource',
                  }
                )}`}
                className="back-text text-decoration-none text-body">
                {backToText}{' '}
                {i18nTranslate('breadCrumb.home', 'Home', {
                  nameSpace: 'ssr-resource',
                })}
              </Link>
            )}
          </div>
          <JsonLd data={schemaData} key="schema-breadcrumb" />
        </>
      )
    }

    return (
      <>
        {/* Mobile Breadcrumb */}
        {!isPlpRedesign && (
          <div
            className={`mobile-breadcrumb ${isPlpPdpRedesign ? 'plp-pdp-redesign' : ''} d-flex d-lg-none`}
            onClick={this.handleBackClick}>
            <div className="arrow-icon">
              {isPdpRedesign ? (
                // New image asset when PDP redesign enabled
                <img
                  src={fullArrowLeft}
                  alt=""
                  className="arrow-icon-img"
                  data-testid="qa-breadcrumb-back-arrow"
                />
              ) : (
                // Legacy inline SVG (kept for backward compatibility)
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ cursor: 'pointer' }}>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.256281 7.61872C-0.0854275 7.27701 -0.0854275 6.72299 0.256281 6.38128L6.38128 0.256282C6.72299 -0.0854266 7.27701 -0.0854266 7.61872 0.256282C7.96043 0.597991 7.96043 1.15201 7.61872 1.49372L2.11244 7L7.61872 12.5063C7.96043 12.848 7.96043 13.402 7.61872 13.7437C7.27701 14.0854 6.72299 14.0854 6.38128 13.7437L0.256281 7.61872Z"
                    fill="#5F5F5F"
                  />
                </svg>
              )}
            </div>
            <span className="back-text">
              {i18nTranslate('back', 'Back', {
                nameSpace: 'ssr-resource',
              })}
            </span>
          </div>
        )}

        <Container
          fluid
          className="responsive-breadcrumbs d-none d-lg-flex px-3">
          <Row noGutters>
            <Col
              className={
                isExpressCheckout() && !getBuyNowInPDP()
                  ? 'mw-max-content-pdp'
                  : 'mw-max-content'
              }>
              <Breadcrumb
                className="d-flex breadcrumb mb-0 p-0 rounded-0"
                listProps={{
                  className:
                    'container-fluid m-0 h-auto p-0 pl-3 align-items-center py-2 text-truncate flex-nowrap',
                }}>
                {view}
                {this.props.children || <></>}
              </Breadcrumb>
              <JsonLd data={schemaData} key="schema-breadcrumb" />
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

export { BreadCrumb }
export default withRouter(BreadCrumb)
